import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/modules/_services/auth.service';
import { FidelidadeService } from 'src/app/modules/_services/fidelidade.service';
import { ValidacaoService } from 'src/app/modules/_services/validacao.service';
import Swal from 'sweetalert2';
import * as alerts from '../../../_functions/alerts';
import { Membro } from '../../../_models/membro';

@Component({
  selector: 'app-cadastro',
  templateUrl: './cadastro.component.html',
  styleUrls: ['./cadastro.component.scss'],
})
export class CadastroComponent implements OnInit {
  acessoForm: UntypedFormGroup;

  membro: Membro = new Membro();
  membroIdoso: number = 0;

  cadastroForm: UntypedFormGroup;
  etapaCadastro: number = 1;
  etapaConcluida: number = 0;
  exibirLoader: boolean = false;
  etapas: number[] = [1, 2, 3, 4];
  quantidadeCaracters = false;
  minCaracters = false;
  maxCaracters = false;
  numberCaracters = false;
  caractersEspecial = false;

  senhaValida: boolean = false;

  buscandoMembro: boolean = false;
  cadastrando: boolean = false;
  entrando: boolean = false;

  precisaAprovador: boolean = false;
  aprovadorValido: boolean = undefined;

  hashIndicacao: string = '';
  origem: number = 0;

  exibePopupGenerico: boolean = false;
  tituloModalGenerico: string = '';
  descricaoModalGenerico: string[] = [];

  mensagemLogin: string = '';
  popupCadastro: string = '';

  dataNascimento: number = undefined;
  iconeDireito: string = '';
  EmailValido: boolean;
  telefoneValido: boolean;
  labelResponsavelValidado: string = '';
  labelEmail: string = 'E-mail';
  loading = {
    loadingEmail: false,
    loadingTelefone: false,
    loadingResponsavel: false,
  };
  idade: number;

  @Output() public clickMudaImagem = new EventEmitter<MouseEvent>();

  public handleClick(event: MouseEvent) {
    this.clickMudaImagem.emit(event);
  }

  @Output() public abrirModalDireto: EventEmitter<null> = new EventEmitter();
  @Output() public abrirAcesso: EventEmitter<null> = new EventEmitter();

  @Output() public cadastroRealizado: EventEmitter<null> = new EventEmitter();

  @Input() public redirectLink: string = '';
  @Input() public idStatus: number = 0;
  @Input() public token: string = '';

  constructor(
    private formBuilder: FormBuilder,
    private validacaoService: ValidacaoService,
    private fidelidadeService: FidelidadeService,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private elRef: ElementRef
  ) {
    this.acessoForm = this.formBuilder.group({
      cpf: ['', [Validators.required, Validators.minLength(11)]],
      senha: ['', [Validators.required]],
    });

    this.cadastroForm = this.formBuilder.group({
      nome: ['', [Validators.required]],
      cpf: ['', [Validators.required, Validators.minLength(11)]],
      dataNascimento: ['', [Validators.required, Validators.minLength(8)]],
      aceiteTermos: [false],
      ddd: [''],
      email: ['', [Validators.required, Validators.email]],
      celular: ['', [Validators.required, Validators.minLength(11)]],
      senha: [
        '',
        [
          Validators.required,
          Validators.pattern(
            '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[A-Za-z\\d$@$!%*?&].{7,}$'
          ),
        ],
      ],
      confirmarSenha: [
        '',
        [
          Validators.required,
          Validators.pattern(
            '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[A-Za-z\\d$@$!%*?&].{7,}$'
          ),
        ],
      ],
      cpfResponsavel: ['', [Validators.minLength(11)]],
    });
  }
  ngOnInit(): void {
    this.ObservarCadastro();

    this.route.queryParams.subscribe((params) => {
      if (params.hashIndicacao) {
        this.hashIndicacao = params.hashIndicacao;
        this.abrirCadastroDireto();
      } else if (params.origem) {
        this.origem = params.origem;
        this.abrirCadastroDireto();
      }
      if (params.popupCadastro) {
        this.popupCadastro = atob(params.popupCadastro);
        if (this.popupCadastro.includes('@')) {
          this.cadastroForm.get('email').setValue(this.popupCadastro);
        } else {
          const cpf = this.popupCadastro.replace(/\D/g, '');
          this.cadastroForm.get('cpf').setValue(cpf);
        }
      }
    });
  }

  private ObservarCadastro() {
    const componenteElemento: HTMLElement = this.elRef.nativeElement;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          if (this.etapaCadastro === 5) this.reset();
          else {
            if (this.cadastroForm.get('email').value)
              this.cadastroForm.get('email').markAsTouched();

            if (this.cadastroForm.get('celular').value)
              this.cadastroForm.get('celular').markAsTouched();
          }
          console.log('O elemento tornou-se visível!');
        }
      });
    });

    observer.observe(componenteElemento);

    return { observer, componenteElemento };
  }


  valuePassword(event: boolean) {
    this.senhaValida = event;
  }

  reset() {
    this.labelResponsavelValidado = '';
    this.telefoneValido = false;
    this.EmailValido = false;
    this.aprovadorValido = undefined;
    this.senhaValida = false;
    this.etapaCadastro = 1;
    this.etapaConcluida = 0;
    this.precisaAprovador = false;

    const cpf = this.cadastroForm.get('cpf').value;
    this.cadastroForm.reset();
    this.cadastroForm.get('cpf').setValue(cpf);
    this.cadastroRealizado.emit(null);
  }

  ngOnChanges(): void { }

  public irParaAcesso() {
    if (this.etapaCadastro === 1) {
      this.etapaCadastro = 1;
      this.abrirAcesso.emit();
    } else {
      this.etapaCadastro -= 1;
    }
  }

  public abrirCadastroDireto() {
    this.abrirModalDireto.emit();
  }

  public irParaEtapa(etapa?: number) {
    if (this.etapaCadastro === 1) {
      if (
        this.cadastroForm.controls['cpf'].valid &&
        this.cadastroForm.controls['nome'].valid
      ) {
        this.obterStatus();
      } else {
        if (!this.cadastroForm.controls['cpf'].valid) {
          this.cadastroForm.controls['cpf'].markAsTouched();
        }
        if (!this.cadastroForm.controls['nome'].valid) {
          this.cadastroForm.controls['nome'].markAsTouched();
        }
      }
      return;
    }

    if (this.etapaCadastro === 2) {
      if (!this.cadastroForm.controls['dataNascimento'].valid) {
        this.cadastroForm.controls['dataNascimento'].markAsTouched();
        return;
      }

      const dateString = this.cadastroForm.controls['dataNascimento'].value;
      const day = parseInt(dateString.substring(0, 2));
      const month = parseInt(dateString.substring(2, 4)) - 1;
      const year = parseInt(dateString.substring(4, 8));
      const dataNascimento = new Date(year, month, day);

      const idade = new Date().getFullYear() - dataNascimento.getFullYear();

      if (idade < 16) return;
      else if (idade >= 18) {
        if (idade >= 65) {
          this.labelEmail = 'E-mail (Opcional)';
          this.cadastroForm.get('email').clearValidators();
          this.cadastroForm.get('email').updateValueAndValidity();
        } else {
          this.labelEmail = 'E-mail';
          this.cadastroForm
            .get('email')
            .setValidators([Validators.required, Validators.email]);

          this.cadastroForm.get('email').updateValueAndValidity();
        }

        this.etapaCadastro++;
        this.etapaConcluida = this.etapaCadastro;
      } else if (idade >= 16 && idade < 18 && this.aprovadorValido) {
        this.etapaCadastro++;
        this.etapaConcluida = this.etapaCadastro;
      }

      return;
    }

    if (this.etapaCadastro === 3) {
      if (
        this.cadastroForm.controls['celular'].valid &&
        this.telefoneValido &&
        this.cadastroForm.controls['email'].valid &&
        (this.EmailValido || this.idade >= 65)
      ) {
        this.etapaCadastro++;
        this.etapaConcluida = this.etapaCadastro;
      } else {
        this.cadastroForm.controls['email'].markAllAsTouched();
        this.cadastroForm.controls['celular'].markAllAsTouched();
      }

      return;
    }

    if (this.etapaCadastro === 4) {
      if (
        this.cadastroForm.controls['senha'].valid &&
        this.cadastroForm.controls['confirmarSenha'].valid
      ) {
        if (
          this.cadastroForm.controls['senha'].value ===
          this.cadastroForm.controls['confirmarSenha'].value
        ) {
          this.cadastrar();
        } else {
          this.cadastroForm.controls['confirmarSenha'].setErrors({
            senhaIncorreta: true,
          });
        }
      } else {
        if (!this.cadastroForm.controls['senha'].valid) {
          this.cadastroForm.controls['senha'].markAsTouched();
        }
        if (!this.cadastroForm.controls['confirmarSenha'].valid) {
          this.cadastroForm.controls['confirmarSenha'].markAsTouched();
        }
      }
      return;
    }
  }

  public verificaEtapa(): boolean {
    if (this.etapaCadastro === 4) {
      if (this.cadastroForm.controls['aceiteTermos'].value) return false;
      else return true;
    }
  }

  public mostrarPopupTermos() {
    this.limparDescricao();
    this.exibirLoader = true;

    this.fidelidadeService.obterConfiguracaoPorDescricao('termos').subscribe(
      (sucesso) => {
        this.processarSucessoTermos(sucesso);
      },
      (falha) => {
        this.processarFalhaTermos(falha);
      }
    );
  }

  private processarSucessoTermos(response: any) {
    let linhas = response.valor.split('\n');

    for (let index = 1; index < linhas.length; index++) {
      if (linhas[index] == '\r') continue;

      this.descricaoModalGenerico.push(`${linhas[index]}<br><br>`);
    }

    this.exibirLoader = false;

    this.exibePopupGenerico = true;
    this.tituloModalGenerico = linhas[0];
  }

  private processarFalhaTermos(fail: any) {
    this.exibirLoader = false;
    console.error('Ocorreu um erro ao tentar obter os termos', fail);
  }

  public ValidarResponsavel() {
    const cpf = this.cadastroForm.controls['cpfResponsavel'].value;

    if (!cpf || cpf.length < 11) {
      const erro = cpf ? { cpf: true } : { required: true };

      this.cadastroForm.controls['cpfResponsavel'].setErrors(erro);
      return;
    }


    this.aprovadorValido = undefined;
    this.loading.loadingResponsavel = true;

    return new Promise((resolve, reject) => {
      this.fidelidadeService.verificarResponsavelValido(cpf).subscribe(
        res => {
          this.loading.loadingResponsavel = false;

          if (!res.valido) {
            this.aprovadorValido = false;

            this.cadastroForm.controls['cpfResponsavel'].setErrors({ responsavelNaoCadastrado: true });
          }
          else {
            this.labelResponsavelValidado = 'O responsável será notificado para aprovar o seu cadastro.';
            this.aprovadorValido = true;
            this.cadastroForm.controls['cpfResponsavel'].setErrors(null);
          }
        },
        error => {
          this.loading.loadingResponsavel = false;
          this.cadastroForm.controls['cpfResponsavel'].setErrors({ responsavelNaoCadastrado: true });
          this.aprovadorValido = false;
        },
      );
    });
  }

  public mostrarPopupRegulamento() {
    this.limparDescricao();
    this.exibirLoader = true;

    this.fidelidadeService
      .obterConfiguracaoPorDescricao('regulamento')
      .subscribe(
        (sucesso) => {
          this.processarSucessoRegulamento(sucesso);
        },
        (falha) => {
          this.processarFalhaRegulamento(falha);
        }
      );
  }

  private processarSucessoRegulamento(response: any) {
    var linhas = response.valor.split('\n');

    for (let index = 0; index < linhas.length; index++) {
      if (linhas[index] == '\r') continue;

      this.descricaoModalGenerico.push(`${linhas[index]}<br><br>`);
    }

    this.exibirLoader = false;
    this.exibePopupGenerico = true;
    this.tituloModalGenerico = linhas[0];
  }

  private processarFalhaRegulamento(fail: any) {
    this.exibirLoader = false;
    console.error('tOcorreu um erro ao tentar obter o regulamento', fail);
  }

  private limparDescricao() {
    this.descricaoModalGenerico = [];
  }

  private obterStatus(): void {
    this.exibirLoader = true;
    const cpfRegex = this.cadastroForm.controls['cpf'].value;
    const cpf = cpfRegex.replace(/[.-]/g, '');
    if (cpf) {
      this.fidelidadeService.obterTokenPorCPFBody(cpf).subscribe(
        (sucesso) => {
          this.exibirLoader = false;
          if ((sucesso.ativo = true && sucesso.tipoStatus !== 6 && sucesso.tipoStatus !== 8 && sucesso.tipoStatus !== 12)) {
            this.router.navigate(['/home'], {
              queryParams: {
                login: btoa('1'),
                popup: btoa(cpf),
              },
            });
            this.abrirAcesso.emit();
          }
          else {
            this.etapaCadastro++;
            this.etapaConcluida = this.etapaCadastro;
          }
        },
        (falha) => {
          console.error('🚀 ~ CadastroComponent ~ obterStatus ~ falha:', falha);
          this.exibirLoader = false;
          this.etapaCadastro++;
          this.etapaConcluida = this.etapaCadastro;
        }
      );
    }
  }

  public cadastrar() {
    this.exibirLoader = true;
    let membro = this.cadastroForm.value;

    this.cadastroForm.controls['ddd'].setValue('55');

    if (this.idStatus === 8 || this.idStatus === 12) {
      this.membro = Object.assign({}, this.membro, this.cadastroForm.value);

      const nascimento: string = membro.dataNascimento;
      const dia = Number(nascimento.substring(0, 2));
      const mes = Number(nascimento.substring(2, 4));
      const ano = Number(nascimento.substring(4, 8));

      var dataFinal = `${ano}/${mes}/${dia}`;

      const nascimentoDate: Date = new Date(dataFinal);

      this.membro.nome = membro.nome;
      this.membro.cpf = membro.cpf;
      this.membro.dataNascimento = nascimentoDate;
      this.membro.aceiteTermo = membro.aceiteTermos;
      this.membro.email = membro.email;
      this.membro.senha = membro.senha;
      this.membro.senhaConfirmacao = membro.senha;
      this.membro.genero = 'N';
      this.membro.telefone =
        '55' + membro.ddd + this.cadastroForm.value.celular;
      this.membro.tipoStatus = this.idStatus;
      this.membro.ativo = true;
      this.membro.enviaComunicacao = true;
      this.membro.queroSerLover = true;
      this.membro.origem = this.origem > 0 ? this.origem : 1;

      if (!membro.aceiteTermos) {
        alerts.exibirToast(
          'warning',
          'É preciso aceitar nossos termos e condições para fazer parte do nosso programa!'
        );
        return;
      }

      if (!this.cadastroForm.valid) return;

      if (membro.email === '') membro.email = null;

      this.fidelidadeService
        .atualizarMembroPorTelaCadastroStatusRecadastro(
          this.membro,
          this.membro.email ?? this.membro.cpf
        )
        .subscribe(
          (res) => {
            this.processarSucessoCadastrarMembro(res);
          },
          (err) => {
            this.processarFalhaCadastrarMembro(err);
          }
        );
    }

    if (this.idStatus != 8 && this.idStatus != 12) {
      if (!membro.aceiteTermos) {
        alerts.exibirToast(
          'warning',
          'É preciso aceitar nossos termos e condições para fazer parte do nosso programa!'
        );
        return;
      }

      if (!this.cadastroForm.valid) return;

      const nascimento: string = membro.dataNascimento;
      const dia = Number(nascimento.substring(0, 2));
      const mes = Number(nascimento.substring(2, 4));
      const ano = Number(nascimento.substring(4, 8));

      var dataFinal = `${ano}/${mes}/${dia}`;

      const nascimentoDate: Date = new Date(dataFinal);

      const nome = membro.nome;
      const telefone = `55${membro.ddd + membro.celular}`;

      if (membro.email === '') membro.email = null;

      membro = {
        cpf: membro.cpf,
        aceiteTermo: membro.aceiteTermos,
        enviaComunicacao: true,
        nome: nome,
        email: membro.email,
        telefone: telefone,
        dataNascimento: nascimentoDate,
        senha: membro.senha,
        senhaConfirmacao: membro.confirmarSenha,
        genero: 'N',
        queroSerLover: true,
        origem: this.origem > 0 ? this.origem : 1,
        ativo: true,
        tipoStatus: 1,
        cpfResponsavel: membro.cpfResponsavel,
        hashIndicacao: this.hashIndicacao,
      };

      this.cadastrando = true;

      this.fidelidadeService.cadastrarMembro(membro).subscribe({
        next: (res: any) => {
          this.exibirLoader = true;
          this.processarSucessoCadastrarMembro(res);
        },
        error: (err: any) => {
          this.processarFalhaCadastrarMembro(err);
        },
      });
    }
  }

  private processarSucessoCadastrarMembro(res: any): void {
    const form = this.cadastroForm.value;
    this.etapaCadastro = 5;

    this.acessoForm = this.formBuilder.group({
      cpf: [form.cpf, [Validators.required, Validators.minLength(11)]],
      senha: [form.senha, [Validators.required]],
    });

    this.cadastrando = false;
    this.exibirLoader = false;

    this.cadastroRealizado.emit(null);
  }

  private processarFalhaCadastrarMembro(err: any): void {
    console.error('Não foi possível cadastrar o membro', err);
    this.exibirLoader = false;
    this.cadastrando = false;

    if (err.includes('E-mail já cadastrado')) {
      Swal.fire({
        icon: 'error',
        title: 'E-mail já em uso',
        text: '',
        timerProgressBar: true,
        timer: 3000,
        showConfirmButton: false,
      });
      return;
    }

    if (err.includes('Lover com o Telefone')) {
      Swal.fire({
        icon: 'error',
        title: 'Telefone já em uso',
        text: '',
        timerProgressBar: true,
        timer: 3000,
        showConfirmButton: false,
      });
      return;
    }

    Swal.fire({
      icon: 'error',
      title: 'Não foi possível realizar o cadastro!',
      text: '',
      timerProgressBar: true,
      timer: 3000,
      showConfirmButton: false,
    });
  }

  getAge(birthDate: Date) {
    var today = new Date();
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  validarDataNascimento() {
    const data = this.cadastroForm.controls['dataNascimento'].value;

    const ano = parseInt(data.substring(4), 10);

    if (ano.toString().length < 4) {
      this.cadastroForm.controls['dataNascimento'].setErrors({
        dataInvalida: true,
      });
      return;
    }

    this.idade = new Date().getFullYear() - ano;

    if (this.idade < 16) {
      this.cadastroForm.controls['dataNascimento'].setErrors({
        menorQue16Anos: true,
      });
      console.log('form', this.cadastroForm);
      this.dataNascimento = this.idade;
      this.precisaAprovador = false;
    } else if (this.idade >= 16 && this.idade <= 17) {
      this.precisaAprovador = true;
      this.dataNascimento = this.idade;
    } else {
      this.precisaAprovador = false;
    }
  }

  acessar() {
    const form = this.acessoForm.value;

    this.entrando = true;

    this.mensagemLogin = '';

    this.authService.loginComSenha(form.cpf, form.senha).subscribe(
      (sucesso) => {
        this.processarSucesso(sucesso);
      },
      (falha) => {
        this.processarFalha(falha);
      }
    );
  }
  processarSucesso(response: any) {
    this.entrando = false;
    this.authService.LocalStorage.salvarDadosLocaisUsuario(response);
    this.fidelidadeService.obterMembro().subscribe({
      next: (res: any) => {
        this.authService.LocalStorage.salvarMembro(res);

        if (this.redirectLink !== '') {
          this.router.navigateByUrl(this.redirectLink);
          return;
        }

        this.router.navigate(['/index']);
      },
    });
  }

  processarFalha(fail: any) {
    this.mensagemLogin = '';
    this.entrando = false;

    if (fail.erro == 0 || fail == 'Registro não encontrado') {
      this.mensagemLogin = `
        Poxaa, você ainda *não se cadastrou* em nossa base, mas não se preocupe,
        temos um *cadastro rapido*, basta clicar em ´*"Ainda não é um Cacau Lover? Cadastre-se"*´`;
    } else if (fail.erro == 1) {
      this.mensagemLogin = `
        Obaaa, ´*você já é um cacau lover*´ porém falta apenas uma etapa para seguir adiante.
        Clique em ´*Esqueci Minha Senha*´ para finalizar seu cadastro!`;
    } else if (fail == 'CPF Bloqueado') {
      alerts.exibirToast('error', fail);
    } else {
      alerts.exibirToast('error', 'Usuário ou senha inválidos!');
    }
  }

  tituloModal() {
    switch (this.etapaConcluida) {
      case 3:
        return 'Contato';

      case 4:
        return 'Cadastre sua senha';

      default:
        return 'Cadastro';
    }
  }

  validarEmailDisponivel() {
    const control = this.cadastroForm.controls['email'];
    const email = control.value;
    if (!email) return;

    const documento = this.cadastroForm.controls['cpf'].value;

    if (control.valid) {
      this.loading.loadingEmail = true;
      this.fidelidadeService.verificarEmailDisponivel(email, documento).subscribe(
        (result) => {
          this.loading.loadingEmail = false;

          if (!result.disponivel) {
            control.setErrors({ emailNaoDisponivel: true });
            this.EmailValido = false;
          }
          else {
            this.EmailValido = true;
            control.setErrors(null);
          }
        },
        (err) => {
          this.loading.loadingEmail = false;
          this.EmailValido = false;
          control.setErrors({ emailNaoDisponivel: true });
        }
      );
    }
  }

  validarTelefoneDisponivel() {
    const controle = this.cadastroForm.controls['celular'];
    const celular = this.cadastroForm.controls['celular'].value;

    if (celular && !controle.valid)
      controle.setErrors({ telefoneInvalido: true });

    const documento = this.cadastroForm.controls['cpf'].value;

    if (controle.valid) {
      this.loading.loadingTelefone = true;
      this.fidelidadeService.verificarTelefoneDisponivel(celular, documento).subscribe(
        (data) => {
          this.loading.loadingTelefone = false;
          if (!data.disponivel) {
            controle.setErrors({ telefoneNaoDisponivel: true });
          } else {
            this.telefoneValido = true;
          }
        },
        (erro) => {
          this.loading.loadingTelefone = false;
          controle.setErrors({ telefoneNaoDisponivel: true });
        }
      );
    }
  }

  resetTelefone() {
    this.telefoneValido = false;
  }

  resetEmail() {
    this.EmailValido = false;
  }
}
